import classNames from 'clsx';
import React from 'react';
import type Slider from 'react-slick';

import { CMSHeading } from '@swf/cms';
import type { ProspectHomepageSlide } from '@swf/cms';

import CarouselSlider from '../../../CarouselSlider';
import type { SharedSliderProps } from '../SliderLayout';

import styles from './HeadingsSlider.scss';

interface Props {
  asNavFor?: Slider;
  sharedSliderProps: SharedSliderProps;
  sliderRef: (slider: Slider) => void;
  slides: ProspectHomepageSlide[];
}

const HeadingsSlider: React.FC<Props> = ({ asNavFor, sharedSliderProps, sliderRef, slides }) => {
  const slidesWithTitles = slides.filter((s) => s.heading.title);
  if (slidesWithTitles.length === 0) {
    return null;
  }

  const twoSlides = slides.length === 2;
  const slidesToShow = twoSlides ? slides.length : slides.length - 0.01;

  return (
    <CarouselSlider
      {...sharedSliderProps}
      asNavFor={asNavFor}
      sliderRef={sliderRef}
      slidesToShow={slidesToShow}
      variableWidth={twoSlides}
      wrapperClassName={classNames(styles.headingsSlider, { [styles.twoSlides]: twoSlides })}
    >
      {slides.map(({ uid, heading }) => (
        <div key={uid} onClick={() => sharedSliderProps.onSwipe?.('')}>
          <CMSHeading {...heading} className={styles.heading} />
        </div>
      ))}
    </CarouselSlider>
  );
};

export default HeadingsSlider;
